export const mergeColonLexeme = (lexeme) => ': ' + lexeme
